import {ColonistMembershipType, LobbyImage} from '@colonist/types'
import {ViewPopup} from './ViewPopup.ts'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables.ts'
import {type TranslationObject} from '@colonist/i18n'
import {type AjaxDataTypes} from '../../../../shared/AjaxDataTypes.ts'
import {AnalyticEventCategory, AnalyticEventType, type AnalyticEventValue} from '../../../../shared/entity_datas/EntityDatas.ts'
import {CA} from '../analytics/Analytics.ts'
import {createDivIn, createHeaderIn, createImgIn, createParagraphIn, createSpanIn} from '../ui_utils/DomUtils.ts'
import {ColonistMembershipProduct} from '../../../../shared/store/ColonistMembershipProduct.ts'
import {createListTooltipIn} from '../ui_utils/TooltipUtils.ts'

export interface PerksListBody {
    image: LobbyImage
    title: TranslationObject
    description: TranslationObject
}

export abstract class ViewPopupBecomeMember extends ViewPopup {
    protected constructor(checkAction: () => void, analyticEventValue?: AnalyticEventValue, xAction: () => void = () => undefined, showXButton: boolean = false) {
        const checkButtonText: TranslationObject = {key: UIUtilsEjsVariables.isUserOnDiscord ? 'strings:popups.becomeAMember.buttonNames.subscribe' : 'strings:popups.becomeAMember.buttonNames.goToStore'}
        const checkActionAnalyticWrapper = () => {
            checkAction()
            if(analyticEventValue != undefined) ViewPopupBecomeMember.sendAnalyticEvent(analyticEventValue)
        }

        super({key: 'strings:roomPage.becomeAMember'}, {key: 'strings:colonistCommon.utils.emptyString'}, checkActionAnalyticWrapper, xAction, true, {checkButtonCustomContent: checkButtonText, showXButton: showXButton})
        if(showXButton) {
            this.changeXButtonText({key: 'strings:popups.becomeAMember.buttonNames.noThanks'})
        }
        this.createBody()

        this.createTooltip()
        this.show()
    }

    protected abstract getBenefits(): PerksListBody[]

    private createBody() {
        const body = this.getBenefits()
        const becomeAMemberContainer = createDivIn(this.body, 'popup-become-a-member-container')
        const perkContainer = createDivIn(becomeAMemberContainer, 'popup-become-a-member-perks')
        for(const perk of body) {
            const perkDiv = createDivIn(perkContainer, 'popup-become-a-member-perk')
            createImgIn(perkDiv, perk.image)
            createHeaderIn(perkDiv, perk.title, '')
            createParagraphIn(perkDiv, perk.description, '')
        }
        if(UIUtilsEjsVariables.isUserOnDiscord) {
            const price = ColonistMembershipProduct.getMembershipProduct(ColonistMembershipType.PremiumMonthly).getDefaultPrice()
            createSpanIn(becomeAMemberContainer, '', {key: 'strings:storePage.sections.membership.billing.paidMonthly', options: {amount: price}})
        }
    }

    private createTooltip(): void {
        const infoIcon = createImgIn(this.header, LobbyImage.InfoIcon, 'popup-header-tooltip-container')
        createListTooltipIn(infoIcon,
            {
                listTitle: {key: 'strings:popups.becomeAMember.tooltip.title'},
                list: 'strings:popups.becomeAMember.tooltip.body',
            }, 'bottom-end', undefined, 'large')
    }

    private static sendAnalyticEvent(eventValue: AnalyticEventValue): void {
        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: eventValue,
        }
        void CA.sendAnalyticEvent(eventData)
    }
}
